import React from "react";
import WorkUnitThumbnail from "../../components/WorkUnitsCard";
import { WorkUnitsCardSkeleton } from "../../components/WorkUnitsCardSkeleton";

interface WorkUnitsGridViewProps {
  data: any[];
  handleProjectClick: (data?: any, toggleTable?: boolean) => void;
  handleEdit: (data: any) => void;
  loading: boolean;
  initialLoading: boolean;
  loadingMore: boolean;
  onLoadMore: () => void;
  hasMore: boolean;
  scrollRef: React.RefObject<HTMLDivElement>;
}

const WorkUnitsGridView: React.FC<WorkUnitsGridViewProps> = ({
  data,
  handleProjectClick,
  handleEdit,
  loading,
  initialLoading,
  loadingMore,
  onLoadMore,
  hasMore,
  scrollRef,
}) => {

  return (
    <div
      ref={scrollRef}
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-4 custom-scrollbar"
    >
      {!loading &&
        data.map((project: any) => (
          <WorkUnitThumbnail
            key={project.id || project.project_id}
            data={project}
            onEdit={(data) => {
              handleEdit(data);
            }}
            onClick={(data) => {
              handleProjectClick(data);
            }}
          />
        ))}
      {(loading || initialLoading) && (
        <>
          {Array(16)
            .fill(0)
            .map((_, i) => (
              <WorkUnitsCardSkeleton key={i} />
            ))}
        </>
      )}
      {(loadingMore || hasMore) && (
        <>
          {Array(8)
            .fill(0)
            .map((_, i) => (
              <WorkUnitsCardSkeleton key={i} />
            ))}
        </>
      )}
    </div>
  );
};

export default WorkUnitsGridView;
